var React = require('react');

function Speeeed (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.75 3L9.26012 8.7647C9.91329 9.44806 9.91329 10.5519 9.26012 11.2353L3.75 17","stroke":"#023247","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M11.75 3L17.2601 8.7647C17.9133 9.44806 17.9133 10.5519 17.2601 11.2353L11.75 17","stroke":"#023247","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":1})]);
}

Speeeed.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = Speeeed;

Speeeed.default = Speeeed;
